import {StoreState} from '../../../App/initialStore';
import {adjustLocationInStore} from '../../components/redux/connectWithRouter';
import {store} from '../../../App/store';

export function getCurrentState(): StoreState {
  return adjustLocationInStore(store.getState());
}
